<template>
   <div v-if="dt" class="d-flex align-items-end flex-column bd-highlight my-1">
      <div class="p-2 result-datatable-count-rows">Resultados obtenidos: {{ totalRecords }}</div>
   </div>
   <div>
      <DataTable
         :value="items"
         :lazy="true"
         :paginator="true"
         :rows="10"
         v-model:filters="filters"
         filterDisplay="row"
         ref="dt"
         dataKey="id"
         :totalRecords="totalRecords"
         :loading="loading"
         @page="onPage($event)"
         @sort="onSort($event)"
         @filter="onFilter($event)"
         :globalFilterFields="['NOMBRESCANDIDATO', 'PRIMERAPELLIDO', 'SEGUNDOAPELLIDO']"
         responsiveLayout="scroll"
         v-model:selection="selectedItems"
         :selectAll="selectAll"
         @row-select="onRowSelect"
         @row-unselect="onRowUnselect"
         stripedRows
         sortField="NOMBRESCANDIDATO"
         :sortOrder="1"
         :rowsPerPageOptions="[10, 20, 50, 100, 300, 500]"
         paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
         currentPageReportTemplate="Resultados {first}-{last} de {totalRecords}"
      >
         <DataColumn
            field="NOMBRESCANDIDATO"
            header="Nombre(s)"
            filterMatchMode="contains"
            :filterMatchModeOptions="matchModeOptions"
            ref="NOMBRESCANDIDATO"
            :sortable="true"
         >
            <template #filter="{ filterModel, filterCallback }">
               <p style="width: 150%" >
                  <InputText type="text" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter" placeholder="Buscar" />
               </p>
            </template>
         </DataColumn>
         <DataColumn field="PRIMERAPELLIDO" header="Primer apellido" filterMatchMode="contains" ref="PRIMERAPELLIDO" :sortable="true">
            <template #filter="{ filterModel, filterCallback }">
               <p style="width: 180%" >
                  <InputText type="text" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter" placeholder="Buscar" />
               </p>
            </template>
         </DataColumn>
         <DataColumn field="SEGUNDOAPELLIDO" header="Segundo apellido" filterMatchMode="contains" ref="SEGUNDOAPELLIDO" :sortable="true">
            <template #filter="{ filterModel, filterCallback }">
               <p style="width: 180%" >
                  <InputText type="text" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter" placeholder="Buscar" />
               </p>
            </template>
         </DataColumn>
         <DataColumn field="NOMBRECANDIDATURA" header="Cargo" :sortable="true"></DataColumn>
         <DataColumn field="ESTADOCON" header="Entidad / Circunscripción" :sortable="true" bodyStyle="text-align: center"></DataColumn>
         <DataColumn field="CIRCUNSCRIPCION_LOCAL" header="Circunscripción local" :sortable="true" bodyStyle="text-align: center"></DataColumn>
         <DataColumn field="MUNICIPIO_ELECCION" header="Municipio/Alcaldía" :sortable="true"></DataColumn>
         <DataColumn field="DISTRITO_ELECCION" header="Distrito" :sortable="true"></DataColumn>
         <DataColumn field="NOMBRESUJETOOBLIGADO" header="Actor político" :sortable="true"></DataColumn>
         <DataColumn header="Acciones" headerClass="result-datatable-column-actions-header" bodyClass="result-datatable-column-actions-body">
            <template #body="{ data }">
               <PrimeButton
                  icon="pi pi-search"
                  class="p-button-text p-button-plain w-100 result-datatable-column-actions-body-button"
                  label="Ver detalle"
                  @click="showResult(data)"
               />
            </template>
         </DataColumn>
      </DataTable>
      <p>-</p>
   </div>
</template>

<script setup>
import { onMounted, defineProps, defineExpose, ref } from "vue";
import { FilterMatchMode } from "primevue/api";
import FiltersDataService from "@/service/FiltersDataService";
import AppConfig from "@/conf/global";

const props = defineProps({
   idProceso: Number,
   idProcesoElectoral: Number,
   idProcesoGeneral: Number,
   ambito: Number,
   idEstado: Number,
   idMunicipio: Number,
   idSujetoObligado: Number,
   idTipoCandidatura: Number,
   idDistrito: Number,
   secondary: Boolean,
   showResult: Function,
});

let nombre = ref(null);
let primerApellido = ref(null);
let segundoApellido = ref(null);

const dt = ref();
const loading = ref(false);
const totalRecords = ref(0);
const items = ref();
const selectedItems = ref();
const selectAll = ref(false);
const filters = ref({
   NOMBRESCANDIDATO: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
   PRIMERAPELLIDO: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
   SEGUNDOAPELLIDO: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
});
const matchModeOptions = ref([{ label: "Starts With", value: FilterMatchMode.STARTS_WITH }]);
const lazyParams = ref({});

const loadLazyData = () => {
   loading.value = true;

   const params = FiltersDataService.setFilters(
      props.idProceso,
      props.idProcesoElectoral,
      props.idProcesoGeneral,
      props.ambito,
      props.idEstado,
      props.idMunicipio,
      lazyParams.value.first,
      lazyParams.value.rows,
      lazyParams.value.sortField,
      lazyParams.value.sortOrder,
      nombre.value,
      primerApellido.value,
      segundoApellido.value,
      props.idSujetoObligado,
      props.idTipoCandidatura,
      props.idDistrito,
      null
   );

   /*FiltersDataService.getContabilidades2(params)
      .then((res) => {
         console.log(res);
      })
      .catch((err) => {
         console.log("Error en lista2");
         console.log(err);
      });*/

   FiltersDataService.getContabilidades(props.secondary, params)
      .then((res) => {
         //console.log(res);
         items.value = res.data.body;

         FiltersDataService.getContabilidadesConteo(props.secondary, params)
            .then((res1) => {
               totalRecords.value = res1.data.body[0].TOTALCONTABILIDAD;
               //console.log(res1.data[0].TOTALCONTABILIDAD);
               loading.value = false;
            })
            .catch((err) => {
               console.log("Error en conteo");
               console.log(err);
               loading.value = false;
            });
      })
      .catch((err) => {
         console.log("Error en lista");
         console.log(err);
         loading.value = false;
      });
};

const onPage = (event) => {
   lazyParams.value = event;
   //console.log(event);
   //console.log(lazyParams);
   loadLazyData();
};
const onSort = (event) => {
   lazyParams.value = event;
   loadLazyData();
};
const onFilter = () => {
   //console.log(filters.value);
   lazyParams.value.filters = filters.value;
   nombre.value = filters.value.NOMBRESCANDIDATO.value;
   primerApellido.value = filters.value.PRIMERAPELLIDO.value;
   segundoApellido.value = filters.value.SEGUNDOAPELLIDO.value;

   if (nombre.value != null) nombre.value = nombre.value.toString().toUpperCase();
   if (primerApellido.value != null) primerApellido.value = primerApellido.value.toString().toUpperCase();
   if (segundoApellido.value != null) segundoApellido.value = segundoApellido.value.toString().toUpperCase();
   loadLazyData();
};

const onRowSelect = () => {
   selectAll.value = selectedItems.value.length === totalRecords.value;
};
const onRowUnselect = () => {
   selectAll.value = false;
};

//let contabilidades2 = ref([]);

defineExpose({
   loadLazyData,
});

onMounted(() => {
   //console.log(props);
   loading.value = false;

   lazyParams.value = {
      first: AppConfig.indexFirstElementDefault,
      rows: dt.value.rows,
      sortField: AppConfig.orderFieldDefault,
      sortOrder: AppConfig.orderTypeDefault,
      filters: filters.value,
   };
   loadLazyData();

   //loadLazyData();
   /*const filters = FiltersDataService.setFilters(
      props.idProceso,
      props.idProcesoElectoral,
      props.idProcesoGeneral,
      props.ambito,
      props.idEstadoEleccion,
      props.idMunicipioEleccion,
      props.indexFirstElement,
      props.pageMaxSize,
      props.orderField,
      props.orderType,
      props.nombre,
      props.primerApellido,
      props.segundoApellido
   );

   FiltersDataService.getContabilidades(filters)
      .then((res) => {
         contabilidades.value = res.data;
         console.log(res);
      })
      .catch((err) => {
         console.log(err);
      });*/
});

/*const resultDialog = ref();

const showDialog = (data) => {
   window.scrollTo(0, 0);
   resultDialog.value.show(data);
};*/
</script>
